// Address
export const OWNER_OF_SERVICE = 'Owner of this service'
export const NOT_OWNER_OF_SERVICE = 'Does not own this service'



// WEBPACK FOOTER //
// ./components/OrderSummaryPaymentScreen/constants.js